"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/formFill/Sheet.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);








/* A panel over the form card; the backdrop or Escape closes it. */
const Sheet = ({ label, onClose, full, children }) => {
  _react.useEffect.call(void 0, () => {
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    _react2.default.createElement('div', { className: "form-fill--sheet-layer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
      , _react2.default.createElement('div', { className: "form-fill--backdrop", onClick: onClose, 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}} )
      , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'form-fill--sheet', { 'form-fill--sheet-full': full }), role: "dialog", 'aria-modal': "true", 'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
        ,  children 
      )
    )
  )
}

exports. default = Sheet
